module.exports = __webpack_public_path__ + "static/media/johnny.7128bc97.jpg";